import { postData } from 'api/services/mediaPlanning/utils';
import { CAMPAIGN } from './mediaPlanning';

export interface MetaBookingStartedResult {
  data: {
    jobId: string;
  };
}

export const bookMetaStart = async (mediaPlanId: string | null) => {
  return postData<MetaBookingStartedResult>(
    `/${CAMPAIGN}/trigger-meta-campaign-reservation`,
    {
      mediaPlanId,
    }
  );
};
